<div class="form-group materialize {{behaviourClasses}}">
	<i *ngIf="prefix" class="{{prefix}} prefix" (click)="this.prefixClick.emit($event)"></i>
	<i *ngIf="suffix" class="{{suffix}} suffix" (click)="this.suffixClick.emit($event)"></i>
	<input class="form-control" [autofocus]="autofocus" [disabled]="disabled" [id]="inputId" [readonly]="readonly"
	 [spellcheck]="spellcheck" [attr.tabindex]="tabindex" [type]="type" [attr.name]="name" [attr.placeholder]="placeholder"
	 [attr.maxlength]="maxlength" (focus)="_handleFocus($event)" (blur)="_handleBlur($event)" (keypress)="_handleKeyPress($event)"
	 [(ngModel)]="value" [ngModelOptions]="ngModelOptions" (change)="_handleChange($event.target.value)" autocomplete="off" />
	<label [for]="inputId">{{label}}</label>
	<validation-messages *ngIf="showFailures" [messages]="failures"></validation-messages>
</div>